import { FileWarning, Clock, FileX, ArrowRight } from 'lucide-react';
import './DocumentStatusAlert.scss';

export default function DocumentStatusAlert({
    documentStatus,
    documentUrlFront,
    documentRejectionReason,
    onOpenProfile,
}) {
    const hasSubmitted = !!documentUrlFront;

    if (documentStatus === 'approved') return null;

    let variant, icon, title, description;

    if (documentStatus === 'rejected') {
        variant = 'rejected';
        icon = <FileX size={22} />;
        title = 'Documentos recusados';
        description = documentRejectionReason
            || 'Reenvie fotos nítidas e legíveis para poder se candidatar novamente.';
    } else if (documentStatus === 'pending' && hasSubmitted) {
        variant = 'pending';
        icon = <Clock size={22} />;
        title = 'Documentos em análise';
        description = 'Assim que forem aprovados, você já poderá se candidatar a vagas normalmente.';
    } else {
        variant = 'missing';
        icon = <FileWarning size={22} />;
        title = 'Envie seus documentos';
        description = 'Você precisa enviar RG, CNH ou outro documento válido para se candidatar a vagas.';
    }

    return (
        <div className={`doc-alert doc-alert--${variant}`}>
            <div className="doc-alert__icon">{icon}</div>
            <div className="doc-alert__content">
                <p className="doc-alert__title">{title}</p>
                <p className="doc-alert__desc">{description}</p>
            </div>
            {variant !== 'pending' && (
                <button className="doc-alert__btn" onClick={onOpenProfile}>
                    {variant === 'rejected' ? 'Reenviar documentos' : 'Enviar documentos'}
                    <ArrowRight size={16} />
                </button>
            )}
        </div>
    );
}